import $ from 'jquery';
import { bindJQuery } from '@/scripts/helpers/library';
import { addedLazyLoadImages } from '@/scripts/helpers/lazyload';
import { commonLegacy } from '@/scripts/helpers/commonLegacy';
import 'slick-carousel/slick/slick';

const showMore = () => {
  if ($('.js-show-more').length) {
    $('.js-show-more').on('click', function () {
      $(this).text($(this).text() === 'Show details' ? 'Hide details' : 'Show details');
      $(this).parent().toggleClass('is-open');
      const hiddenContent = $(this).parent().prev();
      const innerHeight = hiddenContent.find('.section-content__inner').innerHeight();
      hiddenContent.toggleClass('is-open');

      if (hiddenContent.hasClass('is-open')) {
        hiddenContent.css({ height: innerHeight });
      } else {
        hiddenContent.removeAttr('style');
      }
    });
  }
};

$(document).ready(() => {
  addedLazyLoadImages();
  bindJQuery();
  commonLegacy();
  showMore();

  const selector = {
    loaderTrigger: '[data-loader]',
    percentage: '.percentage',
    loader: '.js-loader',
    circle: '.loader .circle',
  };

  function showLoader() {
    $(selector.loader).addClass('is-show');
  }

  function animateCount(el) {
    $(el).each(function () {
      const $this = $(this);
      $({ Counter: 0 }).animate({
        Counter: $this.text(),
      }, {
        duration: 2800,
        easing: 'swing',
        step: function stepFn() {
          $this.text(`${Math.ceil(this.Counter)}%`);
        },
      });
    });
  }

  function animateCircle(el) {
    $(el).each(function () {
      const $this = $(this);
      $({ Counter: 100 }).animate({
        Counter: $this.attr('stroke-dashoffset'),
      }, {
        duration: 2800,
        easing: 'swing',
        step: function stepFn() {
          $this.attr('stroke-dashoffset', this.Counter);
        },
      });
    });
  }

  $(selector.loaderTrigger).on('click', (e) => {
    e.preventDefault();

    if ($(selector.loader).length) { // if loader markup exist in DOM
      showLoader();
      animateCircle(selector.circle);
      animateCount(selector.percentage);
      $('body').addClass('modal-open');
      $('body').keyup((evt) => {
        if (evt.keyCode === 27 || evt.which === 27) {
          evt.preventDefault();
        }
      });
    }
  });

  window.addEventListener('pageshow', (evt) => {
    if (evt.persisted) {
      setTimeout(() => {
        window.location.reload();
      }, 10);
    }
  }, false);

  function showDetails() {
    $('.js-section-details').toggleClass('is-open');
  }

  $('.js-details-show, .js-details-hide').on('click', showDetails);
  $('.js-details-show, .js-details-hide').on('keydown', (e) => {
    if (e.key === 'Enter') {
      showDetails();
    }
  });

  const initBenefitFromCarousel = () => {
    const benefitFromCarousel = $('.js-benefit-from-carousel');
    const windowWidth = $(window).width();
    const destroyBreakpoint = 830;

    if (windowWidth > destroyBreakpoint) {
      if (benefitFromCarousel.hasClass('slick-initialized')) {
        benefitFromCarousel.slick('unslick');
      }
    } else if (benefitFromCarousel.length) {
      benefitFromCarousel.not('.slick-initialized').slick({
        dots: true,
        arrows: false,
        cssEase: 'linear',
        speed: 150,
        autoplaySpeed: 4000,
        autoplay: false,
        infinite: true,
        centerMode: true,
        variableWidth: true,
        pauseOnHover: true,
        pauseOnFocus: false,
        pauseOnDotsHover: !(
          !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        ),
      });
    }
  };
  $(window).on('load resize', initBenefitFromCarousel);
});
